import styled from 'styled-components';

import { SubHeadline, Paragraph } from 'ggApp/shared/common/Typography';
import { ButtonV2 } from '@getgrover/ui';

export const Shipping = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const Title = styled(SubHeadline)`
    margin-bottom: 16px;
`;

export const SubTitle = styled(Paragraph)`
    margin: 0 0 8px;
    color: ${({ theme }) => theme.colors['Level 5']};
`;

export const Btns = styled.div`
    display: flex;
    margin-top: 8px;

    > *:not(:only-child) {
        &:first-child {
            margin-right: 8px;
            min-width: 120px;
        }
    }
`;

export const AddBtn = styled(ButtonV2)`
    margin: 16px 0;
`;
